import Tabs from './Tabs';
import TabPanel from './TabPanel';

export type { TabsProps, TabsCssVars } from './Tabs';
export type { TabPanelProps } from './TabPanel';

Tabs.Panel = TabPanel;
export default Tabs;
